export enum KycProvider {
  notVerified = 'not_verified',
  yes = 'yes',
  yoti = 'yoti',
  yotiDocScan = 'yoti_docscan',
  sumsub = 'sumsub',
}
